module.exports = __webpack_public_path__ + "img/mian.c13f776c.png";